import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import jsonQuery from 'json-query';
import { Grid } from "react-bootstrap";
import cn from 'classnames';

import * as resumeActions from '../actions/actionsResume';

import BackLink from '../components/BackLink'
import SocialBar from '../components/resume/SocialBar'
import Header from '../components/resume/Header'
import Block from '../components/resume/Block'

import dataContent from '../data/content.json';

const positionColumn = (e) => {
  const container = document.querySelector('.main-container.resume');
  const leftCol = document.querySelector('.flex-col--left');

  if (window.matchMedia('(min-width: 768px)').matches) {
    leftCol.style.width = `${container.clientWidth * 0.35 + 30}px`;
  }
  else {
    leftCol.style.width = "auto";
  }
};

class ResumeContainer extends Component {
  constructor (props) {
    super(props);

    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseOut = this.handleMouseOut.bind(this);

    this.contentBlocks = {
      primary: jsonQuery('resume.core[*type=primary]', { data: dataContent }).value,
      secondary: jsonQuery('resume.core[*type=secondary]', { data: dataContent }).value
    }
  }

  componentDidMount () {
    positionColumn();
    window.addEventListener("resize", positionColumn);
  }

  componentWillUnmount () {
    window.removeEventListener("resize", positionColumn);
  }

  handleMouseOver (keywords) {
    this.props.actions.setActiveKeywords(keywords);
  }

  handleMouseOut () {
    this.props.actions.setActiveKeywords([]);
  }

  render() {
    const { activeKeywords } = this.props.resume;
    const blocks = this.contentBlocks;

    return (
      <Grid className="main-container resume">
        <BackLink />
        <div className="flex-row">
          <div className={cn("flex-col--left", {"blurred": activeKeywords.length > 0})}>
            <Header content={dataContent.resume.header} />

            <div className="divider-bottom">
              {blocks.secondary.map((block, i) => 
                <Block 
                  key={i} 
                  content={block} 
                  activeKeywords={activeKeywords}
                />
              )}
            </div>

            <SocialBar content={dataContent.resume.social} />
          </div>

          <div className="flex-col--right">
            {blocks.primary.map((block, i) => 
              <Block 
                key={i} 
                content={block} 
                onMouseOver={this.handleMouseOver} 
                onMouseOut={this.handleMouseOut}
              />
            )}

            <SocialBar className="screen-md-up-hidden" content={dataContent.resume.social} />
          </div>
        </div>
      </Grid>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    resume: state.resume
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(resumeActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResumeContainer);



// WEBPACK FOOTER //
// ./src/containers/ResumeContainer.js